import React from "react"
import styled from "styled-components"
import {
    CrossIcon,
    TableCell,
    TableHeaderCell,
} from "client/components"

export const PermissionTableCell = styled(TableCell)`
    border-right: 1px solid ${(props) => props.theme.tableRowBorderColor};
    padding: 8px 12px;
`
export const PermissionTableHeaderCell = styled(TableHeaderCell)`
    border-right: 1px solid ${(props) => props.theme.tableRowBorderColor};

    &::after {
        display: none;
    }
`
export const PermissionList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`
export const PermissionListItem = styled.li`
    width: fit-content;
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    font-family: ${(props) => props.theme.openSans};
    border-bottom: 1px dashed transparent;
    cursor: default;

    &:hover {
        border-bottom-color: ${(props) => props.theme.permissionBorderBottomColor};
    }
`
export const PermissionListAddItem = styled(PermissionListItem)`

`
export const PermissionLabel = styled.label`
    margin-bottom: 0;
    margin-right: 5px;
    color: ${(props) => props.theme.permissionLabelColor};
`
export const Permission = styled.span`
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`

const CloseButton = styled.div`
    display: inline-block;
    user-select: none;
    cursor: pointer;
    line-height: 0;
    transform: translate(4px, 1px);
    color: ${(props) => props.theme.deleteButtonIdleColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        color: ${(props) => props.theme.deleteButtonIdleHoverColor};
        transition: ${(props) => props.theme.defaultTransition};
    }

    & > i {
        font-size: 13px;
        font-weight: bold;
    }
`
export const DeletePermissionButton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <CloseButton {...props}>
        <CrossIcon />
    </CloseButton>
)
